import * as React from 'react';
import './VerticalWizard.scss';
import Icon from './Icons';

type VerticalWizardStepProps = {
  title: string;
  children: React.ReactNode;
  step?: React.ReactNode;
  connectingLine?: boolean;
  active?: boolean;
  doneStep?: boolean;
};

class VerticalWizardStep extends React.Component<VerticalWizardStepProps> {
  render() {
    const { active, children, title, step, connectingLine, doneStep } =
      this.props;
    return (
      <div className={'d-flex' + (active ? ' active' : '')}>
        <div className="d-flex flex-direction-column">
          <div className={doneStep ? 'step-number-done' : 'step-number'}>
            {step}
          </div>
          <div className={connectingLine ? 'vertical-rule' : undefined} />
        </div>
        <div className="flex-grow m-2 ml-4">
          <h3>{title}</h3>
          {active ? children : null}
        </div>
      </div>
    );
  }
}

type WizardProps = {
  children: Array<
    React.ReactElement<VerticalWizardStepProps, typeof VerticalWizardStep>
  >;
  step: number;
};

export default class VerticalWizard extends React.Component<WizardProps> {
  static Step = VerticalWizardStep;

  render() {
    const children = React.Children.toArray(
        this.props.children,
      ) as WizardProps['children'],
      activeStep = this.props.step;

    return (
      <div className="vertical-wizard">
        {children.map((child, index) => {
          const curStep = index + 1;
          let stepLabel: React.ReactNode = `${curStep}`;
          if (curStep < activeStep) {
            stepLabel = <Icon.Check />;
          }
          return React.cloneElement(child, {
            key: curStep,
            step: stepLabel,
            doneStep: curStep < activeStep,
            active: curStep === activeStep,
            connectingLine:
              curStep < children.length ||
              (curStep === activeStep && curStep === children.length),
          });
        })}
      </div>
    );
  }
}
